// Entry point for parceljs bundling.
// This file should only contain imports.
// In particular, code between imports will not work.
// (https://github.com/parcel-bundler/parcel/issues/3644#issuecomment-542117712)

import "./js/jquery-global";
import "jquery-ui";
import "sortablejs";

// Lastly us
import "./js/site";
import "./js/valuations"